import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { gql } from '../../node_modules/graphql-tag/lib/index.js';

var _templateObject;
var mutationSubmit = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation ContactUsSubmit(\n    $message: String!\n    $user: String!\n    $appName: String!\n    $giid: String!\n    $addressForm: AddressFormInput\n  ) {\n    contactUsSubmit(message: $message, user: $user, appName: $appName, giid: $giid, addressForm: $addressForm)\n  }\n"])));

export { mutationSubmit };
